export default "__VITE_ASSET__DA4_FVHD__"